<template>
	<div>
		<el-dialog
			class="pa_com_dialog"
			:class="size"
			:title="title?title:'温馨提示'"
			:visible.sync="dialogFormVisible"
			:close-on-click-modal="false"
			center
			@close="submitTap('0')"
		>
		  <div>{{conText}}</div>
	      <div style="font-size: 8px;color:grey;margin-top:30px;">{{descText}}</div>
		  <div slot="footer" class="dialog-footer" v-if="type != '1'">
		    <el-button @click="submitTap('1')">取 消</el-button>
		    <el-button type="FF7" @click="submitTap('2')">{{successText?successText:'确 认'}}</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:'alertPop',
		props:['title','conText','status','type','size','descText','successText'],
		watch:{
			status(val){
				 this.dialogFormVisible = val;
			}
		},
		data(){
			return{
				dialogFormVisible:false,
				btnStatus:true
			}
		},
		methods:{
			submitTap(type){
				this.dialogFormVisible = false;
				this.$emit('clock',false,type)
			},
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	
</style>


// WEBPACK FOOTER //
// alertPop.vue?50d4251a